<h1>New Workflow</h1>

<mat-grid-list cols="12" rowHeight="50px">

  <mat-grid-tile
    [colspan]=4
    [rowspan]=2>
      Contract Type:
  </mat-grid-tile>

  <mat-grid-tile
    [colspan]=8
    [rowspan]=2>

      <!-- <div class="left-align">
        <p-autoComplete class="autocomplete-cell"
                        [(ngModel)]="workflowSetup.contractType"
                        required
                        appendTo="body"
                        name="contractType"
                        [suggestions]="filteredContractTypes" 
                        (completeMethod)="filterContractTypes($event)" 
                        
                        [minLength]="1" 
                        placeholder="Contract Types"
                        [dropdown]="true">

            <ng-template let-element pTemplate="item">
                <div style="font-size:18px;font-weight: bold;">
                  {{element}}
                </div>
            </ng-template>
        </p-autoComplete>
      </div> -->
  </mat-grid-tile>  

  <mat-grid-tile
    [colspan]=4
    [rowspan]=2>
      Transaction Type:
  </mat-grid-tile>

  <mat-grid-tile
    [colspan]=8
    [rowspan]=2>

      <!-- <div class="left-align">
        <p-dropdown
          appendTo="body"
          name="transactionType"
          [options]="transactionTypeList"
          [(ngModel)]="workflowSetup.transactionType"
          placeholder="pick one">
        </p-dropdown>
      </div> -->

  </mat-grid-tile> 

  <mat-grid-tile
    [colspan]=4
    [rowspan]=2>
      Document Type:
  </mat-grid-tile>

  <mat-grid-tile
    [colspan]=8
    [rowspan]=2>

      <!-- <div class="left-align">
        <p-dropdown 
            class="autocomplete-cell"
            appendTo="body"
            name="documentType"
            [options]="documentTypesList"
            [(ngModel)]="workflowSetup.documentType"
            placeholder="pick document type">
          </p-dropdown>
      </div> -->

  </mat-grid-tile> 

  <mat-grid-tile
    [colspan]=4
    [rowspan]=2>
      $ Threshold:
  </mat-grid-tile>

  <mat-grid-tile
    [colspan]=8
    [rowspan]=2>

      <!-- <div class="left-align">
        <p-dropdown 
          appendTo="body"
          name="threshold"
          [options]="thresholdList"
          [(ngModel)]="workflowSetup.amountThreshold"
          placeholder="Threshold">
        </p-dropdown>
      </div> -->

  </mat-grid-tile>   

</mat-grid-list>

<br>

  <button
    mat-raised-button color="primary"
    (click)="onSubmit()">
      Start Workflow
  </button>


  &nbsp;

  <button
    mat-raised-button color="accent"
    type="button"
    (click)="cancelSubmit()">
      Cancel
  </button>

<br>
